export function initTypografiePage() {
  try {
    const globalHint = document.getElementById("typografie-hint");
    const hideGlobalHint = () => {
      if (globalHint && !globalHint.classList.contains("is-hidden")) {
        globalHint.classList.add("is-hidden");
      }
    };
    const sliders = document.querySelectorAll(".typografie-size-range");
    sliders.forEach((slider) => {
      const id = slider.id || "";
      const targetId = id.replace("sizeRange-", "preview-line-");
      const line = document.getElementById(targetId);
      if (!line) return;

      const apply = () => {
        const value = parseFloat(slider.value);
        if (!Number.isFinite(value)) return;
        const isMobile = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(max-width: 600px)").matches;
        // Schriftgröße
        line.style.fontSize = value + "em";

        // Defaults für große Größen: einspaltig, kein Umbruch
        line.style.columnCount = "1";
        line.style.whiteSpace = "nowrap";
        line.style.overflowWrap = "normal";
        line.style.wordWrap = "normal"; // Legacy alias
        line.style.lineHeight = "1"; // einheitenlos, multipliziert mit aktueller Schriftgröße
        line.style.height = "";

        // Für kleine Größen mehrspaltig und Umbruch aktivieren
        if (value < 1.5) {
          // Mobile: stets einspaltig
          line.style.columnCount = isMobile ? "1" : "3";
          line.style.whiteSpace = "normal";
          line.style.overflowWrap = "break-word";
          line.style.wordWrap = "break-word";
          line.style.lineHeight = "1.2"; // einheitenlos statt value*1.2em
        } else if (value < 3) {
          line.style.columnCount = isMobile ? "1" : "2";
          line.style.whiteSpace = "normal";
          line.style.overflowWrap = "break-word";
          line.style.wordWrap = "break-word";
          line.style.lineHeight = "1.2";
        } else if (value < 4) {
          // einspaltig, aber mit Umbruch
          line.style.columnCount = "1";
          line.style.whiteSpace = "normal";
          line.style.overflowWrap = "break-word";
          line.style.wordWrap = "break-word";
          line.style.lineHeight = "1.2";
        }
      };

      slider.addEventListener("input", apply);
      slider.addEventListener("change", apply);
      // Erste Interaktion blendet den globalen Hinweis aus
      slider.addEventListener("input", hideGlobalHint);
      line.addEventListener("focus", hideGlobalHint);
      line.addEventListener("pointerdown", hideGlobalHint);
      line.addEventListener("keydown", hideGlobalHint);
      line.addEventListener("input", hideGlobalHint);
      // Bei Fenstergrößenwechsel Spalten neu berechnen
      window.addEventListener("resize", apply);
      window.addEventListener("orientationchange", apply);
      // Nur Plaintext einfügen (kein Rich-Text/HTML)
      line.addEventListener("paste", (e) => {
        try {
          e.preventDefault();
        } catch (_) {}
        const clipboard = e.clipboardData || window.clipboardData;
        const text = clipboard ? clipboard.getData("text/plain") : "";
        // Insert plaintext an Cursorposition
        if (document.queryCommandSupported && document.queryCommandSupported("insertText")) {
          document.execCommand("insertText", false, text);
          return;
        }
        const sel = window.getSelection && window.getSelection();
        if (sel && sel.rangeCount) {
          const range = sel.getRangeAt(0);
          range.deleteContents();
          range.insertNode(document.createTextNode(text));
          range.collapse(false);
          return;
        }
        line.textContent = (line.textContent || "") + text;
      });
      // Initialisieren
      apply();
    });

    // Nach Barba-Transition zur Hash-Ziel-ID scrollen (z. B. #preview-line-slug)
    const scrollToHash = () => {
      const raw = window.location.hash || "";
      if (!raw) return;
      const id = decodeURIComponent(raw.substring(1));
      const el = document.getElementById(id);
      if (!el) return;
      // kleinen Delay, damit Layout/Fonts stehen
      setTimeout(() => {
        try {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (_) {
          const r = el.getBoundingClientRect();
          window.scrollTo({
            top: window.scrollY + r.top - window.innerHeight / 2,
            behavior: "smooth",
          });
        }
      }, 60);
    };

    // Direkt nach Initialisierung versuchen
    requestAnimationFrame(scrollToHash);
    // Auch auf spätere Hash-Änderungen reagieren
    window.addEventListener("hashchange", scrollToHash);
  } catch (e) {
    console.warn("initTypografiePage error", e);
  }
}
